import { IAPI } from '@axo/shared/data-access/api';
import { send } from '../../lib/send.ts';
import { legacy_import } from '@axo/shared/data-access/types';

export function getBankNotes({ url: { integration: baseURL }, token }: IAPI) {
  return ({
    applicationID,
    marketCountry,
  }: {
    applicationID: string;
    marketCountry: string;
  }): Promise<{ Items: legacy_import.Note[] | null }> =>
    send({
      baseURL: baseURL || '',
      token,
      path: `/legacy-import/note/${marketCountry}/${applicationID}`,
      method: 'GET',
    });
}
